import React from 'react'

import Link from 'components/Link'
import Meta from 'components/Meta'
import PasswordChangeForm from 'components/PasswordChangeForm'
import UnauthBox from 'components/UnauthBox'
import UnauthView from 'components/UnauthView'
import paths from 'constants/paths'

export default function PasswordChange() {
  const title = 'Change your password'

  return (
    <UnauthView className="PasswordChange">
      <Meta title={title} />
      <UnauthBox
        title={title}
        actions={
          <Link to={paths.SIGN_IN} icon="plus-circle" muted>Sign in</Link>
        }>
        <p>
          Enter a new password
        </p>
        <PasswordChangeForm />
      </UnauthBox>
    </UnauthView>
  )
}



// WEBPACK FOOTER //
// ./src/views/PasswordChange/PasswordChange.js